module.exports = __webpack_public_path__ + "static/media/promulgation-landing-promo-video.55fad299.png";